import { createContext } from 'react';

import { HoneycombTileData } from '../types/honeycomb.js';

export const HoneycombDataContext = createContext<HoneycombTileData[]>([]);
